module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-full-width"
  }, [_c('div', {
    staticClass: "section-boxed"
  }, [_c('div', {
    staticClass: "portfolio-carousel"
  }, [_vm._m(0), _vm._v(" "), _c('FilterProduct', {
    on: {
      "selectShape": _vm.selectShape,
      "selectDimension": _vm.selectDimension
    }
  }), _vm._v(" "), _c('new-products', {
    attrs: {
      "items": _vm.products,
      "maxHeight": 200
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-header"
  }, [_c('div', {
    staticClass: "carousel-title"
  }, [_c('h4', {
    staticClass: "small-title"
  }, [_vm._v("Danh sách sản phẩm")]), _vm._v(" "), _c('a', {
    staticClass: "link-title",
    attrs: {
      "href": "/products"
    }
  }, [_c('span', {
    staticClass: "more-arrow"
  }, [_vm._v("›")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3d005f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/product/index.vue
// module id = 488
// module chunks = 3